export default __webpack_public_path__ + "static/media/product-8.deda0c72.webp";